<template lang="pug">
div.p-b-0.p-t-md.table-filters
    div.row
        div.col-md-3
            div.m-b-sm.p-t-sm
                h5.m-b-md._300
                    slot(name="title")
        
        div.col-md-9
            div.row
                div.col-md-3.m-y-sm.filter
                    date-picker(
                        ref="datePicker",
                        :use-vuex="false",
                        :max="maxDate",
                        :allow-empty-date="true",
                        @onChange="onChange"
                    )

                //- filter input
                div.col-md-3.m-y-sm.filter
                    outlet-selector(:outlet="activeOutlet", @onChange="onOutletChange")

                slot(name="filters")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['activeOutlet']),

        maxDate() {
            return moment().endOf('year');
        },
    },

    methods: {
        onChange(payload) {
            this.$emit('onDateChange', {
                since: payload.start,
                until: payload.end,
            });
        },

        onOutletChange() {
            this.$emit('onOutletChange', this.activeOutlet);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/report-filter.vue